import React, { useEffect, useRef, useState } from "react";
import "./resellerAgentDashboard.css";
import {
  sections,
  optimumPlan,
  optimumPlanSection,
  customerInfoSection,
} from "../../utils/constants";
import rightArrow from "../../assets/icons/arrow-right.svg";
import addPlanIcon from "../../assets/icons/add plan.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import DashboardFileds from "../../components/dashboardFileds/dashboardFileds";
import {
  calculateOrders,
  clearMobileFilter,
  dashboardAsync,
  fetchStateLocation,
  filterMobileDevice,
} from "../../redux/reducers/resellerAgentDashboard";
import Loader from "../../components/loader/loader";
import Toast from "../../components/toast/toast";
import trash from "../../assets/icons/trash.svg";
import edit from "../../assets/icons/edit.svg";
import isValidUSZipCode from "../../utils/isZipCodeValid";
import validateEmail from "../../utils/isEmailValid";
import validateUSMobileNumber from "../../utils/isMobileValid";
import { Menu, MenuItem, styled, Switch } from "@mui/material";

export default function ResellerAgentDashboard() {
  const { dashboardData, loading, zipcode, orderPrice, filteredMobileDevice } =
    useSelector((state) => state.dashboard);
  const { userData } = useSelector((state) => state.auth);
  const tempFormData = localStorage.getItem("formData");
  const tempConfigData = localStorage.getItem("configOptPlan");
  const [formData, setFormData] = useState(JSON.parse(tempFormData) || {});
  const [configOptPlan, setConfigOptPlan] = useState(
    JSON.parse(tempConfigData) || []
  );
  const [originalConfigOptPlan, setOriginalConfigOptPlan] = useState();
  const [planEmpty, setPlanEmpty] = useState(true);
  const navigate = useNavigate();
  const [errors, setErrors] = useState("");
  const dropdownRef = useRef();
  const dispatch = useDispatch();
  const [planList, setPlanList] = useState([]);
  const [toast, setToast] = useState(null);
  const [planError, setPlanError] = useState(null);
  const [limitReached, setLimitReached] = useState(false);
  const [tempPhoneNumber, setTempPhoneNumber] = useState("");
  const [planSectionErrors, setPlanSectionErrors] = useState({});
  const [showDropdown, setShowDropdown] = useState(false);
  const [editingPlanIndex, setEditingPlanIndex] = useState(null);
  const [dropDownIndex, setDropDownIndex] = useState(null);
  const helperDropdownRef = useRef();

  const ToggleSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 30,
    height: 19,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      "&.Mui-checked": {
        transform: "translateX(13px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: "#F15E22",
          opacity: 1,
          border: 0,
          ...theme.applyStyles("dark", {
            backgroundColor: "#2ECA45",
          }),
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "4px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: theme.palette.grey[100],
        ...theme.applyStyles("dark", {
          color: theme.palette.grey[600],
        }),
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.7,
        ...theme.applyStyles("dark", {
          opacity: 0.3,
        }),
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 14,
      height: 14,
    },
    "& .MuiSwitch-track": {
      borderRadius: 18 / 2,
      backgroundColor: "#E9E9EA",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
      ...theme.applyStyles("dark", {
        backgroundColor: "#39393D",
      }),
    },
  }));

  const validate = (field) => {
    let tempErrors = {};
    if (field === "submit") {
      const fields = [...sections[1].fieldSet];
      !configOptPlan ||
        (configOptPlan.length === 0 &&
          (tempErrors.configOptPlan = "Plan is required"));
      fields.forEach((details, i) => {
        if (details.type === "dropdown") {
          if (!(formData[details.field]?.id && details.required)) {
            tempErrors[details.field] = `${details.name} is required`;
          }
        } else {
          if (
            !(formData[details.field] && formData[details.field].trim()) &&
            details.required
          ) {
            tempErrors[details.field] = `${details.name} is required`;
          }
          if (
            details.field === "email" &&
            formData[details.field]?.trim() &&
            !validateEmail(formData?.email)
          ) {
            tempErrors.email = "Email is invalid.";
          }
        }
      });
      if (!formData.checked) {
        tempErrors.checked = "This field is mandatory";
      }
      if (editingPlanIndex !== null) {
        tempErrors.edit_in_progress =
          "Please complete the edits and proceed with the next steps.";
      }
      setErrors(tempErrors);
      return Object.keys(tempErrors).length === 0;
    } else if (field === "add plan") {
      const requiredFields = ["optimum_plans"];
      requiredFields.forEach((key) => {
        if (
          !formData[key] ||
          (typeof formData[key] === "string" && !formData[key].trim())
        ) {
          tempErrors[key] = `Plan is required`;
        }
      });

      if (formData.radio_buttons === "byod" && !formData.imei) {
        tempErrors.imei = "IMEI number is required";
      }
      if (formData.toggle && !formData.edit_phone_number) {
        tempErrors.add_phone_number = "Phone number is required";
      }
      if (formData.radio_buttons === "add_phone") {
        if (!formData.mobile_devices) {
          tempErrors.mobile_devices = "Mobile device selection is required";
        }
        if (!formData.finance_options_id) {
          tempErrors.finance_options_id = "Financing options are required";
        }
      }

      setPlanSectionErrors(tempErrors);

      return Object.keys(tempErrors).length === 0;
    }
    return true;
  };

  const handleFieldChange = (name, value, index) => {
    (name === "zipcode" && !isValidUSZipCode(value)) ||
    (name === "phone_number" && !validateUSMobileNumber(value))
      ? setErrors((prevState) => ({
          ...prevState,
          [name]: `${
            name === "zipcode" ? "Zip code" : "Contact phone number"
          } is invalid`,
        }))
      : setErrors((prevState) => {
          const newState = { ...prevState };
          delete newState[name];
          return newState;
        });

    if (name === "edit_phone_number") {
      if (!validateUSMobileNumber(value) && editingPlanIndex !== null) {
        setPlanSectionErrors((prevState) => ({
          ...prevState,
          edit_phone_number: "Invalid US mobile number",
          add_phone_number: "Invalid US mobile number",
        }));
      } else {
        setPlanSectionErrors((prevState) => {
          const newState = { ...prevState };
          delete newState.edit_phone_number;
          delete newState.add_phone_number;
          return newState;
        });
      }
      setFormData((prevData) => ({
        ...prevData,
        edit_phone_number: value || "",
      }));
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (name === "toggle") {
      setPlanSectionErrors((prevState) => {
        const newState = { ...prevState };
        delete newState.add_phone_number;
        delete newState.edit_phone_number;
        return newState;
      });
    }

    if (name === "mobile_devices" || name === "finance_options_id") {
      if (value) {
        setPlanError(null);
      }
    }

    if (name === "optimum_plans") {
      if (value !== null && value !== undefined) {
        setFormData((prevData) => {
          const newFormData = { ...prevData };
          delete newFormData.mobile_devices;
          delete newFormData.finance_options_id;
          return newFormData;
        });

        if (editingPlanIndex !== null) {
          setConfigOptPlan((prevConfig) => {
            const updatedConfig = [...prevConfig];
            const currentPlan = updatedConfig[editingPlanIndex];
            if (currentPlan) {
              delete currentPlan.mobile_devices;
              delete currentPlan.finance_options_id;
            }
            return updatedConfig;
          });
        }
        if (value?.id) {
          dispatch(
            filterMobileDevice({
              details: {
                plan_id: value?.id,
              },
            })
          );
        }

        setErrors((prevState) => {
          const newState = { ...prevState };
          delete newState["configOptPlan"];
          return newState;
        });
      } else {
        dispatch(clearMobileFilter());
      }
    }

    let updatedFormData = { ...formData };

    // Handle radio buttons changes
    if (name === "radio_buttons") {
      if (value === "add_phone") {
        setFormData((prevData) => {
          const newFormData = { ...prevData };
          delete newFormData.imei;
          return newFormData;
        });
        if (editingPlanIndex !== null) {
          setConfigOptPlan((prevConfig) => {
            const updatedConfig = [...prevConfig];
            const currentPlan = updatedConfig[editingPlanIndex];
            if (currentPlan?.imei) {
              delete currentPlan.imei;
            }
            return updatedConfig;
          });
        }
        if (formData?.optimum_plans?.id) {
          dispatch(
            filterMobileDevice({
              details: {
                plan_id: formData?.optimum_plans?.id,
              },
            })
          );
        }
      } else if (value === "byod") {
        setFormData((prevData) => {
          const newFormData = { ...prevData };
          delete newFormData.mobile_devices;
          delete newFormData.finance_options_id;
          return newFormData;
        });
        if (editingPlanIndex !== null) {
          setConfigOptPlan((prevConfig) => {
            const updatedConfig = [...prevConfig];
            const currentPlan = updatedConfig[editingPlanIndex];
            if (currentPlan) {
              delete currentPlan.mobile_devices;
              delete currentPlan.finance_options_id;
            }
            return updatedConfig;
          });
        }
      }
    }
    if (name === "imei") {
      if (value.length > 15) {
        value = value.substring(0, 15);
      }
    }
    updatedFormData[name] = value;
    (name === "mobile_devices" || name === "optimum_plans") &&
      value === "" &&
      delete formData["finance_options_id"];
    if (
      name === "optimum_plans" ||
      name === "add_ons" ||
      (formData.radio_buttons === "byod" && name === "imei") ||
      (formData.radio_buttons === "add_phone" &&
        (name === "mobile_devices" || name === "finance_options_id"))
    ) {
      if (value) {
        if (planSectionErrors && planSectionErrors[name]) {
          setPlanSectionErrors((prevState) => {
            const newState = { ...prevState };
            delete newState[name];
            return Object.keys(newState).length === 0 ? null : newState;
          });
        } else if (planSectionErrors) {
          setPlanSectionErrors(null);
        }
      } else {
        if (
          name === "mobile_devices" ||
          (name === "finance_options_id" &&
            formData.radio_buttons === "add_phone") ||
          ["optimum_plans", "add_ons"].includes(name)
        ) {
          setPlanSectionErrors((prevState) => ({
            ...prevState,
            [name]: `Plan is required`,
          }));
        }
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate("submit") && formData && editingPlanIndex === null) {
      const customerData = {
        customer_name: formData?.customer_name,
        business_name: formData?.business_name,
        phone_number: formData?.phone_number,
        email: formData?.email,
        billing_address: formData?.billing_address,
        tax_id: formData?.tax_id,
        zipcode: formData?.zipcode,
        account_number: formData?.account_number,
        state_id: formData?.location.id,
      };
      let orderDetails = [];
      configOptPlan?.map(
        (plan, i) =>
          (orderDetails = [
            ...orderDetails,
            {
              plan_id: plan?.optimum_plans?.id || null,
              mobile_device_id: plan?.mobile_devices?.id || null,
              add_on_id: plan?.add_ons?.id || null,
              finance_option_id: plan?.finance_options_id?.id || null,
              ...(plan?.edit_phone_number
                ? { current_phone_number: plan?.edit_phone_number }
                : {}),
              ...(plan?.imei ? { imei_number: plan?.imei } : {}),
            },
          ])
      );

      dispatch(
        calculateOrders({
          details: {
            customerData: customerData,
            orderDetails: orderDetails,
          },
        })
      )
        .then((res) => {
          const data = {
            customerData: customerData,
            orderDetails: orderDetails,
            orderPrice: res.payload,
          };
          localStorage.setItem("customer_details", JSON.stringify(data));
          localStorage.setItem("formData", JSON.stringify(formData));
          localStorage.setItem("configOptPlan", JSON.stringify(configOptPlan));
          navigate("/cost-breakdown");
        })
        .catch((err) => console.log("err", err));
    } else {
      console.log("Validation failed");
    }
  };

  const addNewPlan = (e) => {
    if (
      validate("add plan") &&
      !!!planSectionErrors?.edit_phone_number &&
      configOptPlan.length < parseInt(process.env.REACT_APP_NUMBER_OF_PLANS)
    ) {
      dispatch(clearMobileFilter());
      clearFormFields();
      // Create a new plan object with edit_phone_number
      const newPlan = optimumPlan.reduce((acc, plan) => {
        if (plan.field !== "edit_phone_number" && formData[plan.field]) {
          acc[plan.field] = formData[plan.field];
        }
        return acc;
      }, {});

      if (formData.toggle) {
        newPlan.edit_phone_number = formData?.edit_phone_number || "";
      }

      if (formData.radio_buttons === "byod") {
        newPlan.imei = formData.imei || "";
      }

      setConfigOptPlan([...configOptPlan, newPlan]);

      setErrors((prevState) => {
        const newState = { ...prevState };
        delete newState["configOptPlan"];
        return newState;
      });

      setPlanError(null);

      const updatedFormData = { ...formData };
      optimumPlan.forEach((plan) => delete updatedFormData[plan.field]);

      if (formData.radio_buttons === "byod") {
        updatedFormData.imei = "";
      }

      // Update formData to store the edit_phone_number for the new plan
      setFormData((prevData) => ({
        ...prevData,
        edit_phone_number: "",
      }));

      setTempPhoneNumber("");
      setPlanSectionErrors({});
      setPlanEmpty(true);
    } else if (
      configOptPlan.length === parseInt(process.env.REACT_APP_NUMBER_OF_PLANS)
    ) {
      setLimitReached(true);
    }
  };

  const clearFormFields = () => {
    setFormData((prevData) => {
      const updatedFormData = { ...prevData };
      optimumPlan.forEach((plan) => delete updatedFormData[plan.field]);
      if (formData?.radio_buttons === "byod") {
        updatedFormData.imei = "";
      }
      return updatedFormData;
    });
    setTempPhoneNumber("");
    setPlanSectionErrors({});
    setPlanEmpty(true);
  };

  const removePlan = (e) => {
    e.preventDefault();
    let updatedList = configOptPlan.filter(
      (_, index) => index !== parseInt(e.currentTarget.id)
    );
    setConfigOptPlan(updatedList);
    setLimitReached(false);
  };

  const handleEditPlan = (i) => {
    setEditingPlanIndex(i);
    const planToEdit = configOptPlan[i];

    setOriginalConfigOptPlan(JSON.parse(JSON.stringify(configOptPlan)));
    // Temporarily copy the plan data
    setFormData((prevData) => ({
      ...prevData,
      ...planToEdit,
    }));
    setErrors((prevState) => {
      const newState = { ...prevState };
      delete newState.edit_in_progress;
      return newState;
    });
    setPlanSectionErrors({});
  };
  const updateEditedPlan = (actionType) => {
    if (actionType === "update") {
      const isValid = validate("add plan");
      if (!isValid) {
        return;
      }
    }
    if (
      actionType === "update" &&
      editingPlanIndex !== null &&
      !!!planSectionErrors?.edit_phone_number
    ) {
      const latestPlanData = optimumPlan.reduce((acc, plan) => {
        if (plan.field !== "edit_phone_number" && formData?.[plan?.field]) {
          acc[plan.field] = formData?.[plan?.field];
        }
        return acc;
      }, {});
      if (formData?.edit_phone_number !== undefined) {
        latestPlanData.edit_phone_number = formData?.edit_phone_number;
      }
      if (formData?.radio_buttons === "byod") {
        latestPlanData.imei = formData.imei || "";
      }

      if (!formData?.toggle) {
        latestPlanData.toggle = false;
        latestPlanData.edit_phone_number = "";
      }
      const updatedConfigOptPlan = [...configOptPlan];

      updatedConfigOptPlan[editingPlanIndex] = {
        ...updatedConfigOptPlan[editingPlanIndex],
        ...latestPlanData,
      };

      setConfigOptPlan(updatedConfigOptPlan);
      setPlanSectionErrors({});

      const updatedFormData = JSON.parse(JSON.stringify(formData));
      if (!formData.toggle) {
        updatedFormData.toggle = false;
        updatedFormData.edit_phone_number = "";
      }
      optimumPlan.forEach((plan) => delete updatedFormData[plan.field]);

      if (formData.radio_buttons === "byod") {
        updatedFormData.imei = "";
      }

      setFormData(updatedFormData);
      setTempPhoneNumber(formData?.phone_number || "");
      setPlanEmpty(true);
      setErrors((prevState) => {
        const newState = { ...prevState };
        delete newState.edit_in_progress;
        return newState;
      });
    } else if (actionType === "cancel" && editingPlanIndex !== null) {
      setConfigOptPlan(originalConfigOptPlan);
      setEditingPlanIndex(null);
      setErrors((prevState) => {
        const newState = { ...prevState };
        delete newState.edit_in_progress;
        return newState;
      });
      setPlanSectionErrors({});

      const resetFormData = { ...formData };
      Object.keys(resetFormData).forEach((key) => {
        if (optimumPlan.find((plan) => plan.field === key)) {
          delete resetFormData[key];
        }
        if (key === "imei" || key === "edit_phone_number") {
          resetFormData[key] = "";
        }
        if (key === "toggle" || key === "radio_buttons") {
          if (originalConfigOptPlan[editingPlanIndex][key] !== undefined) {
            resetFormData[key] = originalConfigOptPlan[editingPlanIndex][key];
          } else {
            resetFormData[key] = ""; // or default value if any
          }
        }
      });
      setFormData(resetFormData);
    }
    setEditingPlanIndex(null);
  };

  const getState = (zipcode) => {
    delete formData["location"];
    dispatch(fetchStateLocation({ zipcode }))
      .then((resp) => {
        if (resp.payload?.location === "") {
          setFormData((prevData) => {
            const updatedData = { ...prevData };
            return updatedData;
          });
          setErrors((prevState) => ({
            ...prevState,
            zipcode: "Zip code is invalid",
          }));
          return;
        }

        setFormData((prevData) => {
          const updatedData = {
            ...prevData,
            location: {
              id: resp.payload.state_id,
              name: resp.payload.location,
              state_code: resp.payload.state_code,
            },
          };
          return updatedData;
        });

        setErrors((prevState) => {
          const updatedErrors = { ...prevState };
          delete updatedErrors.zipcode;
          delete updatedErrors.location;
          return updatedErrors;
        });
      })
      .catch(() => {
        setFormData((prevData) => ({
          ...prevData,
          location: "",
        }));
        setErrors((prevState) => ({
          ...prevState,
          location: "Unable to fetch state for the given ZIP code",
        }));
      });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        helperDropdownRef.current &&
        !helperDropdownRef.current.contains(event.target)
      ) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showDropdown]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (loading && dashboardData?.length === 0) dispatch(dashboardAsync());
    localStorage.removeItem("customer_details");
  }, []);

  useEffect(() => {
    if (!loading && dashboardData?.length !== 0) {
      const toastSent = sessionStorage.getItem("email_sent");
      toastSent &&
        setToast({
          header: "Plan Send Successfully",
          message:
            "Email has been sent to the customer. Please notify the customer agent.",
        });
    }
    setTimeout(() => {
      setToast(null);
      sessionStorage.removeItem("email_sent");
    }, 3000);
  }, [loading, dashboardData]);

  useEffect(() => {
    if (optimumPlan.every((plan) => formData.hasOwnProperty("optimum_plans"))) {
      formData?.optimum_plans ? setPlanEmpty(false) : setPlanEmpty(true);
    }
  }, [formData]);

  useEffect(() => {
    const configPlanTemplate = configOptPlan.map((plan, i) => {
      return (
        <div key={i} className="fields solid-border">
          <div
            className={
              editingPlanIndex !== i ? "plan-actions" : "plan-actions-edit"
            }
          >
            <button
              type="button"
              className="edit-plan"
              onClick={() => handleEditPlan(i)}
            >
              <img src={edit} alt="edit plan" />
            </button>
            <button
              type="button"
              className="remove-plan"
              onClick={removePlan}
              id={i}
            >
              <img src={trash} alt="delete plan" />
            </button>
          </div>
          {optimumPlanSection.fieldSet.map((field) => {
            if (["optimum_plans", "add_ons"].includes(field.field)) {
              return (
                <div key={field.field} className="field-container">
                  <DashboardFileds
                    key={field.field}
                    field={field}
                    dropdown={editingPlanIndex === i}
                    id={formData?.optimum_plans?.id}
                    fieldValue={editingPlanIndex === i ? formData : plan}
                    validationError={errors}
                    disabled={!(editingPlanIndex === i)}
                    dropdownRef={dropdownRef}
                    planEmpty={planEmpty}
                    requiredMark={editingPlanIndex === i && field.required}
                    index={i}
                    dropdownDatas={
                      editingPlanIndex === i
                        ? field.field === "optimum_plans"
                          ? dashboardData[field.field]?.filter((data) =>
                              data?.state_code ===
                              formData?.location?.state_code
                                ? data
                                : !data?.state_code && data
                            )
                          : field.field === "add_ons"
                          ? dashboardData[field.field]?.filter((data) =>
                              data?.state_code ===
                              formData?.location?.state_code
                                ? data
                                : !data?.state_code && data
                            )
                          : dashboardData[field.field]
                        : []
                    }
                    setField={handleFieldChange}
                  />
                  {editingPlanIndex === i &&
                    planSectionErrors?.[field.field] && (
                      <p className="error-message">
                        {planSectionErrors?.[field.field]}
                      </p>
                    )}
                </div>
              );
            }
            if (
              (editingPlanIndex === i &&
                formData?.radio_buttons === "add_phone" &&
                ["mobile_devices", "finance_options_id"].includes(
                  field.field
                )) ||
              (editingPlanIndex !== i &&
                plan?.radio_buttons === "add_phone" &&
                ["mobile_devices", "finance_options_id"].includes(field.field))
            ) {
              return (
                <div key={field.field} className="field-container">
                  <DashboardFileds
                    key={field.field}
                    field={field}
                    id={formData?.optimum_plans?.id}
                    dropdown={editingPlanIndex === i}
                    fieldValue={
                      editingPlanIndex === i
                        ? {
                            ...plan,
                            mobile_devices:
                              formData?.mobile_devices || plan.mobile_devices,
                            finance_options_id:
                              formData?.finance_options_id ||
                              plan.finance_options_id,
                          }
                        : plan
                    }
                    validationError={errors}
                    disabled={!(editingPlanIndex === i)}
                    dropdownRef={dropdownRef}
                    planEmpty={planEmpty}
                    index={i}
                    setField={handleFieldChange}
                    dropdownDatas={
                      editingPlanIndex === i
                        ? field.field === "mobile_devices" &&
                          formData?.optimum_plans?.id
                          ? filteredMobileDevice
                          : field.field === "finance_options_id"
                          ? formData?.mobile_devices
                            ? dashboardData[field.field]
                            : []
                          : dashboardData[field.field]
                        : []
                    }
                  />
                  {planSectionErrors?.[field.field] &&
                    editingPlanIndex === i && (
                      <p className="error-message">
                        {planSectionErrors?.[field.field]}
                      </p>
                    )}
                </div>
              );
            }
            if (field.type === "toggle") {
              return (
                <div
                  key={field.field}
                  className="field-container configure-container configure-mobile-container"
                >
                  <label className="configure-label field-name">
                    {field.name}&nbsp;
                    {(
                      editingPlanIndex === i
                        ? !!formData?.[field?.field]
                        : !!plan?.toggle
                    ) ? (
                      <span>*</span>
                    ) : (
                      <></>
                    )}
                  </label>
                  <div className="toggle-container">
                    <label className="toggle-switch">
                      <ToggleSwitch
                        checked={
                          editingPlanIndex === i
                            ? formData?.[field?.field]
                            : plan?.toggle
                        }
                        disabled={!(editingPlanIndex === i)}
                        onChange={(e) =>
                          handleFieldChange(field.field, e.target.checked, i)
                        }
                      />
                      <span className="slider">
                        {(
                          editingPlanIndex === i
                            ? !!formData?.[field?.field]
                            : !!plan?.toggle
                        )
                          ? "Yes"
                          : "No"}
                      </span>
                    </label>

                    {(editingPlanIndex === i
                      ? formData?.toggle
                      : plan?.toggle) && (
                      <input
                        type="number"
                        className="configure-input"
                        value={
                          editingPlanIndex === i
                            ? formData?.edit_phone_number
                            : plan?.edit_phone_number
                        }
                        onChange={(e) => {
                          if (editingPlanIndex === i) {
                            handleFieldChange(
                              "edit_phone_number",
                              e.target.value
                            );
                          }
                        }}
                        disabled={!(editingPlanIndex === i)}
                      />
                    )}
                    {editingPlanIndex === i &&
                      planSectionErrors?.add_phone_number && (
                        <p
                          className="error-message plans-error-message"
                          style={{
                            display: (
                              editingPlanIndex === i
                                ? formData?.toggle
                                : plan?.toggle
                            )
                              ? "block"
                              : "none",
                          }}
                        >
                          {planSectionErrors?.add_phone_number}
                        </p>
                      )}
                  </div>
                </div>
              );
            }
            if (field.type === "radio") {
              return (
                <div
                  key={field.field}
                  className="field-container configure-container"
                >
                  <label className="configure-label">{field.name}</label>
                  <div className="configure-radio-container">
                    {field.options.map((option) => (
                      <label
                        key={option.value}
                        className="radio-container-label"
                      >
                        <input
                          type="radio"
                          className="configure-radio-btn"
                          name={field.field + i}
                          value={option.value}
                          checked={
                            editingPlanIndex === i
                              ? formData?.[field?.field] === option.value
                              : plan?.[field.field] === option.value
                          }
                          onChange={(e) =>
                            handleFieldChange(field.field, e.target.value)
                          }
                          disabled={!(editingPlanIndex === i)}
                        />
                        {option.label}
                      </label>
                    ))}
                  </div>
                </div>
              );
            }
            return null;
          })}
          {(editingPlanIndex === i
            ? formData?.radio_buttons === "byod"
            : plan?.radio_buttons === "byod") && (
            <>
              <div className="field-container configure-container">
                <label className="configure-label field-name">
                  Device IMEI <span>*</span>
                </label>
                <input
                  className="configure-input configure-imei-input"
                  value={
                    editingPlanIndex === i ? formData?.imei : plan?.imei || ""
                  }
                  onChange={(e) => handleFieldChange("imei", e.target.value)}
                  disabled={!(editingPlanIndex === i)}
                  maxLength={15}
                  pattern="\d*"
                  type="number"
                />
                {editingPlanIndex === i && planSectionErrors?.imei && (
                  <p className="error-message">{planSectionErrors?.imei}</p>
                )}
                <div ref={helperDropdownRef} className="imei-container">
                  <p
                    className="find-imei"
                    onClick={() => {
                      setShowDropdown(!showDropdown);
                      setDropDownIndex(i);
                    }}
                  >
                    Where is my IMEI
                  </p>
                  {showDropdown && dropDownIndex === i && (
                    <ul className="find-imei-menu">
                      <li className="find-imei-menu-items">
                        <strong className="find-imei-title">iPhone</strong>
                        <p className="find-imei-content">
                          Settings &rarr; General &rarr; About
                        </p>{" "}
                      </li>
                      <li className="find-imei-menu-items">
                        <strong className="find-imei-title">Android</strong>
                        <p className="find-imei-content">
                          Settings → About Phone → Status
                        </p>
                      </li>
                      <li className="find-imei-menu-items">
                        <strong className="find-imei-title">iPad</strong>
                        <p className="find-imei-content">
                          Settings → General → About
                        </p>
                        <p className="find-imei-info">
                          * You may also be able to see the IMEI printed on the
                          back of your ipad
                        </p>
                      </li>
                    </ul>
                  )}
                </div>
              </div>
              <div className="check-compatibility-contianer">
                <a
                  href="https://www.optimum.com/mobile/bring-your-own-device"
                  className="check-compatibility"
                  target="_blank"
                >
                  Check Device Compatibility
                </a>
              </div>
            </>
          )}

          {editingPlanIndex === i && (
            <div className="plan-edit-actions">
              <button
                type="button"
                className="cancel-btn"
                onClick={() => updateEditedPlan("cancel")}
              >
                Cancel
              </button>
              <button
                type="button"
                className="apply-btn"
                disabled={planSectionErrors?.edit_phone_number}
                onClick={() => updateEditedPlan("update")}
              >
                Apply
              </button>
            </div>
          )}
        </div>
      );
    });

    setPlanList(configPlanTemplate);
  }, [
    editingPlanIndex,
    formData,
    tempPhoneNumber,
    filteredMobileDevice,
    configOptPlan,
    planSectionErrors,
    showDropdown,
  ]);
  return (
    <>
      <Loader loading={!userData || loading} />
      {toast && <Toast toast={toast} />}
      <div className="reseller-agent-dashboard">
        <form onSubmit={handleSubmit} ref={dropdownRef} noValidate>
          {
            <div
              key={customerInfoSection.name}
              className={customerInfoSection.style}
            >
              <h1>{customerInfoSection.name}</h1>
              <div className="fields">
                {customerInfoSection.fieldSet.map((field, i) => (
                  <div key={field.field} className="field-container">
                    <DashboardFileds
                      key={field.field}
                      type={field.type}
                      field={field}
                      dropdown={field.dropdown}
                      setField={handleFieldChange}
                      fieldValue={formData}
                      validationError={errors}
                      disabled={field.field === "location" ? true : false}
                      dropdownRef={dropdownRef}
                      planEmpty={planEmpty}
                      requiredMark={field.required}
                      limit={field.limit}
                      getState={getState}
                    />
                    {field?.field === "billing_address" && (
                      <p className="find-imei-info">
                        * P.O. Box not allowed as billing address
                      </p>
                    )}
                    {field?.field === "zipcode" && (
                      <a
                        href="https://business.optimum.com/ChannelPartner/Storefront?quote=true"
                        className="check-serviceability"
                        target="_blank"
                      >
                        Serviceability Check
                      </a>
                    )}
                  </div>
                ))}
              </div>
            </div>
          }
          {/* Configure Optimum Plan */}
          {
            <div
              key={optimumPlanSection.name}
              className={optimumPlanSection.style}
            >
              <h1>{optimumPlanSection.name}</h1>
              <div className="fields configure-fields">
                {optimumPlanSection.fieldSet.map((field) => {
                  if (
                    field.dropdown &&
                    ["optimum_plans", "add_ons"].includes(field.field)
                  ) {
                    return (
                      <div
                        key={field.field}
                        className="field-container configure-container"
                      >
                        <DashboardFileds
                          key={field.field}
                          field={field}
                          dropdownDatas={
                            field.field === "optimum_plans"
                              ? dashboardData[field.field]?.filter((data) =>
                                  data?.state_code ===
                                  formData?.location?.state_code
                                    ? data
                                    : !data?.state_code && data
                                )
                              : field.field === "add_ons"
                              ? dashboardData[field.field]?.filter((data) =>
                                  data?.state_code ===
                                  formData?.location?.state_code
                                    ? data
                                    : !data?.state_code && data
                                )
                              : dashboardData?.[field?.field]
                          }
                          dropdown={field.dropdown}
                          setField={handleFieldChange}
                          fieldValue={editingPlanIndex === null ? formData : {}}
                          disabled={editingPlanIndex !== null}
                          validationError={errors}
                          dropdownRef={dropdownRef}
                          planEmpty={planEmpty}
                          requiredMark={field.required}
                        />
                        {editingPlanIndex === null &&
                          planSectionErrors?.[field.field] && (
                            <p className="error-message">
                              {planSectionErrors?.[field.field]}
                            </p>
                          )}
                      </div>
                    );
                  }

                  if (field.type === "radio") {
                    return (
                      <div
                        key={field.field}
                        className="field-container configure-container"
                      >
                        <label className="configure-label">{field.name}</label>
                        <div className="configure-radio-container">
                          {field?.options?.map((option) => (
                            <label
                              key={option.value}
                              className="radio-container-label"
                            >
                              <input
                                disabled={editingPlanIndex !== null}
                                type="radio"
                                className="configure-radio-btn"
                                name={field.field}
                                value={option.value}
                                checked={
                                  editingPlanIndex === null &&
                                  formData?.[field?.field] === option.value
                                }
                                onChange={(e) =>
                                  handleFieldChange(field.field, e.target.value)
                                }
                              />
                              {option.label}
                            </label>
                          ))}
                        </div>
                      </div>
                    );
                  }

                  if (field.type === "toggle") {
                    return (
                      <div
                        key={field.field}
                        className="field-container configure-container"
                      >
                        <label className="configure-label field-name">
                          {field.name} &nbsp;
                          {formData?.[field?.field] &&
                          editingPlanIndex === null ? (
                            <span>*</span>
                          ) : (
                            <></>
                          )}
                        </label>
                        <div className="toggle-container toggle-input-container">
                          <label className="toggle-switch ">
                            <ToggleSwitch
                              disabled={editingPlanIndex !== null}
                              checked={
                                editingPlanIndex === null &&
                                formData?.[field?.field]
                              }
                              onChange={(e) =>
                                handleFieldChange(field.field, e.target.checked)
                              }
                            />
                            <span className="slider">
                              {formData?.[field?.field] &&
                              editingPlanIndex === null
                                ? "Yes"
                                : "No"}
                            </span>
                          </label>
                          {formData?.[field?.field] &&
                            editingPlanIndex === null && (
                              <div>
                                <input
                                  type="number"
                                  className="configure-input"
                                  placeholder="Enter Phone Number"
                                  value={formData?.edit_phone_number}
                                  onChange={(e) => {
                                    const newPhoneNumber = e.target.value;
                                    handleFieldChange(
                                      "edit_phone_number",
                                      e.target.value
                                    );
                                    if (
                                      !validateUSMobileNumber(newPhoneNumber)
                                    ) {
                                      setPlanSectionErrors((prevState) => ({
                                        add_phone_number:
                                          "Invalid US mobile number",
                                        ...prevState,
                                        edit_phone_number:
                                          "Invalid US mobile number",
                                      }));
                                    } else {
                                      setPlanSectionErrors((prevState) => {
                                        const newState = { ...prevState };
                                        delete newState.edit_phone_number;
                                        return newState;
                                      });
                                    }
                                  }}
                                  maxLength={11}
                                  disabled={editingPlanIndex !== null}
                                />
                                {planSectionErrors?.add_phone_number && (
                                  <p className="error-message">
                                    {planSectionErrors?.add_phone_number}
                                  </p>
                                )}
                              </div>
                            )}
                        </div>
                      </div>
                    );
                  }

                  return null;
                })}

                {/* Conditional fields for selected device option */}
                {formData?.radio_buttons === "byod" &&
                  editingPlanIndex === null && (
                    <>
                      <div className="field-container configure-container">
                        <label className="configure-label field-name">
                          Device IMEI <span>*</span>
                        </label>
                        <input
                          type="number"
                          className="configure-input configure-imei-input"
                          placeholder="Enter your IMEI number"
                          value={
                            editingPlanIndex === null ? formData?.imei : ""
                          }
                          onChange={(e) =>
                            handleFieldChange("imei", e.target.value)
                          }
                          maxLength={15}
                          disabled={editingPlanIndex !== null}
                        />
                        {planSectionErrors?.imei && (
                          <p className="error-message">
                            {planSectionErrors?.imei}
                          </p>
                        )}
                        <div ref={helperDropdownRef} className="imei-container">
                          <p
                            className="find-imei"
                            onClick={() => {
                              setShowDropdown(!showDropdown);
                              setDropDownIndex(null);
                            }}
                          >
                            Where is my IMEI
                          </p>
                          {showDropdown && dropDownIndex === null && (
                            <ul className="find-imei-menu">
                              <li className="find-imei-menu-items">
                                <strong className="find-imei-title">
                                  iPhone
                                </strong>
                                <p className="find-imei-content">
                                  Settings &rarr; General &rarr; About
                                </p>{" "}
                              </li>
                              <li className="find-imei-menu-items">
                                <strong className="find-imei-title">
                                  Android
                                </strong>
                                <p className="find-imei-content">
                                  Settings → About Phone → Status
                                </p>
                              </li>
                              <li className="find-imei-menu-items">
                                <strong className="find-imei-title">
                                  iPad
                                </strong>
                                <p className="find-imei-content">
                                  Settings → General → About
                                </p>
                                <p className="find-imei-info">
                                  * You may also be able to see the IMEI printed
                                  on the back of your ipad
                                </p>
                              </li>
                            </ul>
                          )}
                        </div>
                      </div>
                      <div className="check-compatibility-contianer">
                        <a
                          href="https://www.optimum.com/mobile/bring-your-own-device"
                          className="check-compatibility"
                          target="_blank"
                        >
                          Check Device Compatibility
                        </a>
                      </div>
                    </>
                  )}
                {formData?.radio_buttons === "add_phone" &&
                  editingPlanIndex === null && (
                    <>
                      {optimumPlanSection.fieldSet
                        .filter((field) =>
                          ["mobile_devices", "finance_options_id"].includes(
                            field.field
                          )
                        )
                        .map((field) => {
                          return (
                            <div
                              key={field.field}
                              className="field-container configure-container"
                            >
                              <DashboardFileds
                                key={field.field}
                                field={field}
                                dropdownDatas={
                                  field.field === "mobile_devices" &&
                                  formData?.optimum_plans?.id
                                    ? filteredMobileDevice
                                    : field.field === "finance_options_id" &&
                                      !formData?.mobile_devices
                                    ? []
                                    : dashboardData[field.field]
                                }
                                dropdown={field.dropdown}
                                id={formData?.optimum_plans?.id}
                                setField={handleFieldChange}
                                fieldValue={
                                  editingPlanIndex === null ? formData : {}
                                }
                                validationError={errors}
                                disabled={editingPlanIndex !== null}
                                dropdownRef={dropdownRef}
                                planEmpty={planEmpty}
                                requiredMark={field.required}
                              />
                              {planSectionErrors?.[field.field] && (
                                <p className="error-message">
                                  {planSectionErrors?.[field.field]}
                                </p>
                              )}
                            </div>
                          );
                        })}
                    </>
                  )}

                <button
                  type="button"
                  className="btn add-plan configure-add-plan"
                  onClick={addNewPlan}
                  disabled={
                    editingPlanIndex !== null ||
                    planSectionErrors?.edit_phone_number
                  }
                >
                  Add Plans <img src={addPlanIcon} alt="add plan" />
                </button>
              </div>
              {!planError && errors && (
                <p className="error">{errors?.configOptPlan}</p>
              )}
              {planError && (
                <p className="error">{planError?.finance_options_id}</p>
              )}
              {limitReached && (
                <p className="error">
                  Maximum of {process.env.REACT_APP_NUMBER_OF_PLANS} plans can
                  be requested.
                </p>
              )}
              {planList.length !== 0 && (
                <div className="selected-plan">
                  {planList.map((plan, index) => (
                    <React.Fragment key={index}>
                      {plan}
                      {index === editingPlanIndex &&
                        errors?.edit_in_progress && (
                          <p className="error-message edit-error">
                            {errors?.edit_in_progress}
                          </p>
                        )}
                    </React.Fragment>
                  ))}
                </div>
              )}
            </div>
          }
          <div className="checkbox-container">
            <div className="checkbox">
              <input
                type="checkbox"
                value={formData && formData?.checked}
                checked={formData && formData?.checked}
                onChange={(e) => handleFieldChange("checked", e.target.checked)}
              />
              <p>
                Completed the customer’s pre-qualification questions and is
                ready to proceed with the credit check
              </p>
            </div>
            {errors && <p className="error">{errors.checked}</p>}
          </div>
          <p className="device-available-note">
            <span>*</span>If the device you selected is not available, we will
            contact you promptly to provide an update and discuss alternative
            options
          </p>
          <button className="btn" type="submit">
            Proceed <img src={rightArrow} alt="proceed icon" />
          </button>
        </form>
      </div>
    </>
  );
}
